<template>
  <div>
    <v-alert
      color="blue"
      text
      type="info"
    >{{ $t("personal.data.info") }}</v-alert>
    <h5>
      {{ $t("form.account_configuration") }}
    </h5>
    <v-row>
      <v-col cols="12" sm="6">
        <v-text-field
          v-model="investigator.account.username"
          :label="$t('form.username')"
          required
          readonly
          class="disable-events"
          hide-details
        ></v-text-field>
      </v-col>
      <v-col cols="12" sm="6" lg="3">
        <v-text-field
          v-model="investigator.account.uid"
          :label="$t('form.uid')"
          required
          readonly
          class="disable-events"
          hide-details
        ></v-text-field>
      </v-col>
      <v-col cols="12" sm="6" lg="3">
        <v-text-field
          v-model="investigator.account.expiration_date"
          :label="$t('form.expiration_date')"
          required
          readonly
          class="disable-events"
          hide-details
        ></v-text-field>
      </v-col>
    </v-row>

    <h5 class="py-3 mt-2 mb-2">
      {{  $t("form.password") }}
    </h5>
    <v-row>
      <v-col cols="12" class="py-0">
        <p class="password-link-help mb-2">
          {{ $t("form.password_change_help") }}
        </p>
        <v-btn outlined class="password-link-button" @click="sendActivationLinkSelf">
          <v-icon left>mdi-mail</v-icon>
          {{ $t("button.sendActivationLinkShort") }}
        </v-btn>
      </v-col>
    </v-row>

    <h5 class="py-3 mt-3" v-if="isInternal">
      {{ $t("form.building") }}
    </h5>
    <v-row v-if="isInternal">
      <v-col cols="8" sm="5" class="py-0">
        <v-text-field
          :append-icon="showAlarmCode ? 'mdi-eye' : 'mdi-eye-off'"
          :value="showAlarmCode ? investigator.account.alarm_code : $t('form.code_hidden')"
          @click:append="showAlarmCode = !showAlarmCode"
          :label="$t('form.alarm_code')"
          readonly
          hide-details
        ></v-text-field>
      </v-col>
    </v-row>

    <v-row>
      <v-col cols="12" class="text-left pb-0">
        <h5>{{ $t("form.services") }}</h5>
      </v-col>
    </v-row>

    <div v-if="sortedServices.length > 0">
      <v-row>
        <v-col
          cols="12"
          sm="6"
          md="4"
          v-for="service in sortedServices"
          :key="service.code"
        >
          <div class="service-item">
            <span class="service-name">{{ service.name }}</span>
            <v-tooltip v-if="service.restricted" top>
              <template v-slot:activator="{ on, attrs }">
                <v-icon
                  small
                  color="red"
                  class="service-icon"
                  v-bind="attrs"
                  v-on="on"
                >
                  mdi-lock
                </v-icon>
              </template>
              {{ $t("form.service_restricted_tooltip") }}
            </v-tooltip>
            <v-btn
              icon
              small
              color="primary"
              class="service-info-button"
              @click="openServiceInfo(service)"
            >
              <v-icon small>mdi-information-outline</v-icon>
            </v-btn>
          </div>
        </v-col>
      </v-row>
    </div>
    <v-row v-else class="justify-center">
      <v-col cols="12" md="6">
        <v-alert dense text type="info">
          {{ $t("investigator.no.services") }}
        </v-alert>
      </v-col>
    </v-row>

    <div
      v-if="isInternal">

      <h5 class="py-3">
        {{ $t("form.vinculations") }}
      </h5>

      <div
        v-if="
          investigator.vinculations.active.length > 0 ||
            investigator.vinculations.expired.length > 0
        "
      >
        <h6 class="text-left" v-if="investigator.vinculations.active.length > 0">
          {{ $t("title.vinculationsActive") }}
        </h6>
        <v-row
          v-for="(vinculation, index) in investigator.vinculations.active"
          :key="index"
        >
          <v-col cols="6" md="4">
            <v-text-field
              v-model="vinculation.category.internal_name"
              readonly
              :label="$t('label.category')"
              class="disable-events"
              hide-details
            ></v-text-field>
          </v-col>
          <v-col cols="6" md="4">
            <v-text-field
              :value="$t('vinculation.types.' + vinculation.type)"
              readonly
              :label="$t('table.type')"
              class="disable-events"
              hide-details
            ></v-text-field>
          </v-col>
          <v-col cols="6" md="2">
            <v-text-field
              v-model="vinculation.start_date"
              :label="$t('label.startDate')"
              readonly
              class="disable-events"
              hide-details
            ></v-text-field>
          </v-col>
          <v-col cols="6" md="2">
            <v-text-field
              v-model="vinculation.end_date"
              :label="$t('label.endDate')"
              readonly
              class="disable-events"
              hide-details
            ></v-text-field>
          </v-col>
        </v-row>
        <h6 class="text-left" v-if="investigator.vinculations.expired.length > 0">
          {{ $t("title.vinculationsExpired") }}
        </h6>
        <v-row
          v-for="(vinculation, index) in investigator.vinculations.expired"
          :key="investigator.vinculations.active.length + index"
        >
          <v-col cols="6" md="5">
            <v-text-field
              v-model="vinculation.category.internal_name"
              readonly
              :label="$t('label.category')"
              class="disable-events"
              hide-details
            ></v-text-field>
          </v-col>
          <v-col cols="6" md="3">
            <v-text-field
              :value="$t('vinculation.types.' + vinculation.type)"
              readonly
              :label="$t('table.type')"
              class="disable-events"
              hide-details
            ></v-text-field>
          </v-col>
          <v-col cols="6" md="2">
            <v-text-field
              v-model="vinculation.start_date"
              :label="$t('label.startDate')"
              readonly
              class="disable-events"
              hide-details
            ></v-text-field>
          </v-col>
          <v-col cols="6" md="2">
            <v-text-field
              v-model="vinculation.end_date"
              :label="$t('label.endDate')"
              readonly
              class="disable-events"
              hide-details
            ></v-text-field>
          </v-col>
        </v-row>
      </div>
      <div v-else>
        <v-row class="justify-center">
          <v-col cols="12" md="6">
            <v-alert dense text type="info">
              {{ $t("investigator.no.vinculations") }}
            </v-alert>
          </v-col>
        </v-row>
      </div>


      <h5 class="py-3">
        {{ $t("form.workplaces") }}
      </h5>

      <div v-if="investigator.workplace !== ''">
        <v-row>
          <v-col cols="12" md="6">
            <v-text-field
              v-model="investigator.workplace.name"
              :label="$t('label.laboratory')"
              readonly
              hide-details
              class="disable-events"
            ></v-text-field>
          </v-col>
          <v-col cols="6" md="3">
            <v-text-field
              v-model="investigator.workplace.place_code"
              :label="$t('label.place')"
              readonly
              hide-details
              class="disable-events"
            ></v-text-field>
          </v-col>
          <v-col cols="6" md="3">
            <v-text-field
              v-model="investigator.workplaceAssignation.expiration_date"
              :label="$t('label.expirationDate')"
              readonly
              hide-details
              class="disable-events"
            ></v-text-field>
          </v-col>
        </v-row>
      </div>
      <div v-else>
        <v-row class="justify-center">
          <v-col cols="12" lg="6">
            <v-alert
              dense
              text
              type="info"
            >
              {{ $t("investigator.no.workplaces") }}
            </v-alert>
          </v-col>
        </v-row>
      </div>
    </div>
    <v-dialog v-model="serviceInfoDialog" max-width="600px">
      <v-card v-if="selectedService">
        <v-card-title class="headline">
          {{ selectedService.name }}
        </v-card-title>
        <v-card-text>
          <div class="mb-4">
            <strong>{{ $t("form.description") }}:</strong>
            <div
              v-if="getServiceDescription(selectedService)"
              v-html="getServiceDescription(selectedService)"
            />
            <div v-else>
              {{ $t("table.features.missingDescription") }}
            </div>
          </div>
          <div class="mb-2">
            <strong>{{ $t("form.restricted") }}:</strong>
            <span>
              {{
                selectedService.restricted
                  ? $t("table.features.restricted")
                  : $t("table.features.notRestricted")
              }}
            </span>
          </div>
          <div class="mb-2">
            <strong>{{ $t("form.requires_agreement") }}:</strong>
            <span>
              {{
                selectedService.requires_agreement
                  ? $t("table.features.requiresAgreement")
                  : $t("table.features.notRequiresAgreement")
              }}
            </span>
          </div>
          <div>
            <strong>{{ $t("form.documentation_link") }}:</strong>
            <span v-if="selectedService.documentation_link">
              <a
                :href="selectedService.documentation_link"
                target="_blank"
                rel="noopener noreferrer"
              >
                {{ selectedService.documentation_link }}
              </a>
            </span>
            <span v-else>-</span>
          </div>
        </v-card-text>
        <v-card-actions>
          <v-spacer />
          <v-btn text @click="closeServiceInfo">
            {{ $t("button.close") }}
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import axios from "axios";
import { normalizeServices } from "../../utils/service";

export default {
  props: {
    person: Number
  },
  data: () => ({
    investigator: {
      account: {
        services: []
      },
      vinculations: {
        active: [],
        expired: []
      },
      vinculationSelected: "",
      workplace: "",
      workplaceAssignation: ""
    },
    listServices: [],
    showAlarmCode: false,
    serviceInfoDialog: false,
    selectedService: null
  }),

  computed: {
    sortedServices() {
      return this.listServices
        .slice()
        .filter(service => service.hidden !== true)
        .sort((a, b) => {
          const orderDiff = (a.order || 0) - (b.order || 0);
          if (orderDiff !== 0) {
            return orderDiff;
          }
          return String(a.name || "").localeCompare(String(b.name || ""));
        });
    }
  },

  watch: {
    serviceInfoDialog(val) {
      if (!val) {
        this.selectedService = null;
      }
    }
  },

  methods: {
    openServiceInfo(service) {
      this.selectedService = service;
      this.serviceInfoDialog = true;
    },
    closeServiceInfo() {
      this.serviceInfoDialog = false;
    },
    getServiceDescription(service) {
      if (!service || !service.description) {
        return "";
      }
      const locale = this.$i18n && this.$i18n.locale ? this.$i18n.locale : "es";
      if (service.description[locale]) {
        return service.description[locale];
      }
      return (
        service.description.es ||
        service.description.en ||
        service.description.gl ||
        ""
      );
    },
    getAccount() {
      const path = this.$store.state.endpoint + "/account/" + this.person;
      axios
        .get(path)
        .then(response => {
          this.investigator.account = response.data;
          let path = this.$store.state.endpoint + "/service/no-basic";
          axios
            .get(path)
            .then(response => {
              normalizeServices(response.data).forEach(service => {
                if (this.investigator.account.services.includes(service.id)) {
                  this.listServices.push(service);
                }
              });
            })
            .catch(error => {
              console.log(error);
            });
        })
        .catch(error => {
          console.log(error);
        });
    },
    getServices() {
      let path = this.$store.state.endpoint + "/service/no-basic";
      axios
        .get(path)
        .then(response => {
          normalizeServices(response.data).forEach(service => {
            if (this.investigator.account.services.includes(service.id)) {
              this.listServices.push(service);
            }
          });
        })
        .catch(error => {
          console.log(error);
        });
    },
    getLastWorkplaceAssignation(id) {
      let path =
        this.$store.state.endpoint + "/workplaceAssignation/last/" + id;

      axios
        .get(path)
        .then(response => {
          this.investigator.workplaceAssignation = response.data;
          if (response.data.length !== 0) {
            this.getWorkplace(response.data.workplace);
          }
        })
        .catch(error => {
          console.log(error);
        });
    },
    getWorkplace(id) {
      let path = this.$store.state.endpoint + "/workplace/" + id;

      axios
        .get(path)
        .then(response => {
          this.investigator.workplace = response.data;
        })
        .catch(error => {
          console.log(error);
        });
    },
    getInvestigator() {
      const path = this.$store.state.endpoint + "/person/" + this.person;
      axios
        .get(path)
        .then(response => {
          this.investigator.person = response.data;
        })
        .catch(error => {
          console.log(error);
        });
    },
    getVinculations() {
      const path =
        this.$store.state.endpoint + "/vinculation/person/" + this.person;
      axios
        .get(path)
        .then(response => {
          let current = new Date().toISOString().substr(0, 10);
          response.data.forEach(vinculation => {
            if (vinculation.end_date < current) {
              this.investigator.vinculations.expired.push(vinculation);
            } else {
              this.investigator.vinculations.active.push(vinculation);
            }
          });
        })
        .catch(error => {
          console.log(error);
        });
    },
    sendActivationLinkSelf(){
      let path = this.$store.state.endpoint + "/account/" + this.person + "/sendActivationLinkSelf";
      axios
        .patch(path, {})
        .then(response => {
          this.$store.commit("alert", {
            color: "success",
            text: this.$t("message.correct.sendEmailSelf")
          });
        })
        .catch(error => {
          console.log(error);
          this.$store.commit("alert", {
            color: "error",
            text: this.$t("message.error.sendEmailSelf")
          });
        });
    }
  },
  created() {
    this.getAccount();
    this.getInvestigator();
    if(this.$store.getters.isInternal){
      this.getLastWorkplaceAssignation(this.person);
      this.getVinculations();
    }
  }
};
</script>

<style scoped>
.disable-events {
  pointer-events: none
}

.password-link-button {
  max-width: 100%;
  white-space: nowrap;
}

.password-link-help {
  max-width: 720px;
}

@media (max-width: 959px) {
  .password-link-button {
    width: 100%;
  }
}

.service-item {
  display: flex;
  align-items: center;
}

.service-name {
  margin-right: 0.35rem;
}

.service-icon {
  margin-right: 0.15rem;
}

.service-info-button {
  margin-left: -0.1rem;
}
</style>
